import { PkCardTypes } from 'src/pkScripts/Helpers/PkCardTypes';
import {
  TileExtension, ITileLocalExtensionContext,
  disableWithCollapsing
} from 'tessa/ui/tiles';
import { CdCardTypes } from '../Helpers/CdCardTypes';


export class CdDisableCardCreateCopyTileExtension extends TileExtension {

  public initializingLocal(context: ITileLocalExtensionContext) {
    const panel = context.workspace.leftPanel;
    const editor = panel.context.cardEditor;
    let typeid;
    if (editor == null || editor.cardModel == null ||
      editor.cardModel.cardType.id == null) {
      return;
    }
    typeid = editor.cardModel.cardType.id;
    if (typeid != null) {

      // TES-12348 Исключение блоков стройки из Тессы. Для исключенных типов карточек все опреации недоступны
      if (typeid == CdCardTypes.PkZosRvDocumentypeID /* TES-12237 */
        || typeid == CdCardTypes.PkGlazingOrderTypeID /* TES-12238 */
        || typeid == CdCardTypes.IrdDocumentTypeID /* TES-12295 */
        || typeid == CdCardTypes.ArDocumentIdpTypeID /* TES-12239 */
        || typeid == CdCardTypes.PkAdditionalWorksContractOrderTypeID 	// TES-12241 Отключение АРФО
        || typeid == PkCardTypes.PkProtocolTypeID 				       	// TES-12243 Отключение Протоколов
        || typeid == CdCardTypes.PkRequestForMaterialsTypeID 				// TES-12240 Отключение Заявок на материалы
        || typeid == CdCardTypes.PkExecutiveDocumentationTypeID 			// TES-12553 Отключение ИД
        || typeid == CdCardTypes.PkExecutiveSchemeTypeID 					// TES-12554 Отключение ИС
        || typeid == CdCardTypes.TechnicalDocumentationTypeID 			// TES-12555 Отключение ТД       
        
      ) {
        panel.tiles.forEach((tile) => {
          disableWithCollapsing(tile);
        });
        return;
      }

      if ((CdCardTypes.CopyTileCardTypes.indexOf(typeid) > -1 || PkCardTypes.CopyTileCardTypes.indexOf(typeid) > -1)) {
        const otherTile = panel.tryGetTile('CardOthers');
        if (otherTile != null) {
          let createCardCopy = otherTile.tryGetTile('CreateCardCopy');
          if (createCardCopy != null) {
            disableWithCollapsing(createCardCopy);
          }
        }
      }
    }
  }

}